import { ConnectedProps } from "react-redux";
import React from "react";

import AddEditForm from "../AddEditForm";
import connector from "./Container";

const AddUser = ({ actions, state }: ConnectedProps<typeof connector>) => {
  return <AddEditForm isAdd={true} actions={actions} state={state} />;
};

export default AddUser;
